import styled from "styled-components";

export const MessageDataEmpty = styled.span`
    font-size: 30px;
    font-weight: 700;
    color: #b7aeae;
`;